import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { Box, TextField } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { IntlShape } from 'react-intl';

import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';
import {EvoachButton} from "../Button";

export interface CopyLinkComponent extends BaseComponent {
  type: 'copyLink';
  props: CopyLinkProps;
}
export interface CopyLinkProps {
  link?: string;
  buttonText: string;
}

export const CopyLink: React.FC<CopyLinkProps> = ({ link, buttonText }) => {
  const linkText: string = link && link !== '' ? link : window.location.href;
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto max-content',
        columnGap: '15px',
        alignItems: 'center',
      }}
    >
      <TextField
        disabled
        variant="outlined"
        value={linkText}
        sx={{ backgroundColor: 'white' }}
      />
      <EvoachButton
        variant="contained"
        endIcon={<LinkIcon />}
        onClick={() => {
          navigator.clipboard.writeText(linkText);
        }}
        sx={{ justifySelf: 'right' }}
      >
        {buttonText}
      </EvoachButton>
    </Box>
  );
};

export const renderCopyLinkAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );

    const payload = actionMetadata.action.payload;

    newContext.widgetData.push({
      type: 'copyLink',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        link: translateWithFallback(intl, payload.link),
        buttonText: translateWithFallback(intl, payload.buttonText),
      },
    });
    return newContext;
  });
};
